var _this = this,
    _jsxFileName = "/builds/zillow/adtech-product/constellation/zrs-cms-messaging/src/components/feature/connections/PLUpsell/PLUpsellWrapper.jsx";

import React from 'react';
import PropTypes from 'prop-types';
import { useYieldCallback } from '@zillow/yield-callback';
import PLUpsellTemplate from './PLUpsellTemplate';
import { concatWithDelimiter } from '../../../../utils/stringUtils';
import { NewLaneEvent } from '../../../../eventing/NewLaneEvent';
import { DSP_BRAND, DSP_EXPERIENCE } from '../../../internal/constants';
import { formNewLaneEventPayload } from '../../../../eventing/newLaneEventPayload';
import { CLICKSTREAM_EVENT_TYPE } from '../../../../eventing/clickStreamEventSchema';
import { useOnsiteMessagingImpressionEvent } from '../../../internal/OnsiteMessageEventingHooks/useOnsiteMessagingImpressionEvent';
import { useOnsiteMessagingIntentToShowEvent } from '../../../internal/OnsiteMessageEventingHooks/useOnsiteMessagingIntentToShowEvent';
export var PLUpsellWrapper = function PLUpsellWrapper(_ref) {
  var actionLink = _ref.actionLink,
      actionText = _ref.actionText,
      actionType = _ref.actionType,
      background = _ref.background,
      bodyMarkdownText = _ref.bodyMarkdownText,
      eventData = _ref.eventData,
      newLaneEventData = _ref.newLaneEventData,
      additionalClickStreamData = _ref.additionalClickStreamData,
      headingMarkdownText = _ref.headingMarkdownText,
      icon = _ref.icon,
      iconFontColor = _ref.iconFontColor,
      media = _ref.media,
      gaAction = _ref.gaAction,
      gaCategory = _ref.gaCategory,
      gaLocation = _ref.gaLocation,
      gaSurface = _ref.gaSurface,
      gaTreatment = _ref.gaTreatment,
      overrideMargin = _ref.overrideMargin,
      additionalProps = _ref.additionalProps,
      showAdvertisement = _ref.showAdvertisement,
      tagInput = _ref.tagInput,
      trackingParameter = _ref.trackingParameter;
  var upsellIdPieces = [gaSurface, gaLocation, gaTreatment];
  var upsellIdentifier = concatWithDelimiter(upsellIdPieces, '|');
  var signalForTriggerTracking = additionalProps.signalForTriggerTracking;

  var onHoverCTA = function onHoverCTA() {
    NewLaneEvent({
      brand: DSP_BRAND,
      experience: DSP_EXPERIENCE,
      sharedJsonStr: JSON.stringify(Object.assign({
        event_type: 'interaction',
        interaction_type: 'hover'
      }, eventData))
    }, formNewLaneEventPayload(CLICKSTREAM_EVENT_TYPE.HOVER, newLaneEventData, additionalClickStreamData), {
      category: gaCategory,
      action: gaAction,
      label: concatWithDelimiter(['Hover', upsellIdentifier], '|')
    });
  };

  var onClickUpsellButton = useYieldCallback(function () {
    NewLaneEvent({
      brand: DSP_BRAND,
      experience: DSP_EXPERIENCE,
      sharedJsonStr: JSON.stringify(Object.assign({
        event_type: 'interaction',
        interaction_type: 'click'
      }, eventData))
    }, formNewLaneEventPayload(CLICKSTREAM_EVENT_TYPE.INTERACTION, newLaneEventData, additionalClickStreamData), {
      category: gaCategory,
      action: gaAction,
      label: concatWithDelimiter(['Click', upsellIdentifier], '|')
    });

    if (actionLink) {
      window.open(actionLink, '_blank');
    }
  });
  var ref = useOnsiteMessagingImpressionEvent({
    eventData: eventData,
    newLaneEventData: newLaneEventData,
    additionalClickStreamData: additionalClickStreamData
  });
  useOnsiteMessagingIntentToShowEvent({
    eventData: eventData,
    newLaneEventData: newLaneEventData,
    additionalClickStreamData: additionalClickStreamData,
    gaEventData: {
      category: gaCategory,
      action: gaAction,
      label: concatWithDelimiter(['Display', upsellIdentifier], '|')
    },
    signalForTriggerTracking: signalForTriggerTracking
  });
  return /*#__PURE__*/React.createElement("div", {
    ref: ref,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 107,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(PLUpsellTemplate, {
    actionLink: actionLink,
    actionText: actionText,
    actionType: actionType,
    background: background,
    bodyMarkdownText: bodyMarkdownText,
    headingMarkdownText: headingMarkdownText,
    icon: icon,
    iconFontColor: iconFontColor,
    media: media,
    onClickUpsellButton: onClickUpsellButton,
    onHoverCTA: onHoverCTA,
    additionalProps: additionalProps,
    overrideMargin: overrideMargin,
    gaSurface: gaSurface,
    gaLocation: gaLocation,
    gaTreatment: gaTreatment,
    showAdvertisement: showAdvertisement,
    tagInput: tagInput,
    trackingParameter: trackingParameter,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 108,
      columnNumber: 13
    }
  }));
};
PLUpsellWrapper.defaultProps = {
  actionLink: '',
  actionText: 'Click',
  actionType: 'url_link',
  background: 'backgroundBlue',
  bodyMarkdownText: '',
  eventData: {},
  newLaneEventData: {},
  additionalClickStreamData: {},
  headingMarkdownText: '',
  icon: 'heartHome',
  iconFontColor: '',
  media: {
    alt: '',
    src: ''
  },
  gaAction: '',
  gaCategory: '',
  gaLocation: '',
  gaSurface: '',
  gaTreatment: '',
  overrideMargin: '16px 16px 16px 16px',
  additionalProps: {},
  showAdvertisement: false,
  tagInput: 'ADVERTISEMENT',
  trackingParameter: ''
};
PLUpsellWrapper.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Destination URL
   */
  actionLink: PropTypes.string,

  /**
   * Text on button
   * default value: Click
   */
  actionText: PropTypes.string,

  /**
   * Type of action
   * default value: url_link
   */
  actionType: PropTypes.string,

  /**
   * Background color in component
   * */
  background: PropTypes.oneOf(['backgroundBlue', 'backgroundWhite']),

  /**
   * Message used in component
   */
  bodyMarkdownText: PropTypes.string,

  /**
   * Event data object, passed by parent component
   */
  // eslint-disable-next-line zillow/react/forbid-prop-types
  eventData: PropTypes.object,

  /**
   * New Lane Event data object, passed by parent component
   */
  // eslint-disable-next-line zillow/react/forbid-prop-types
  newLaneEventData: PropTypes.object,

  /**
   * Additional Clickstream data object, passed by parent component
   */
  // eslint-disable-next-line zillow/react/forbid-prop-types
  additionalClickStreamData: PropTypes.object,

  /**
   * Headline of your message
   */
  headingMarkdownText: PropTypes.string,

  /**
   * Icon used in your messaging. Currently 'dollar', 'home', 'logo', 'phone',
   * 'salesign', 'pigggy', 'ZOHome', 'houseWithDollarSign', 'hangingSign', 'hangingSignV2',
   * 'testimonialIcon', 'hourglassIcon', 'moneyIcon', 'heartHome', 'comparableHome',
   * 'appHome' & 'calendar' are valid.
   * Default icon is a zillow logo.
   * */
  icon: PropTypes.string,

  /**
   * The constellation color code for the icon's drawing color.
   * Available constellation color codes could be found at
   * http://constellation.pages.zgtools.net/constellation-site/constellation-api.html#section-colors
   */
  iconFontColor: PropTypes.string,
  media: PropTypes.shape({
    /**
     * The alt text of the image.
     */
    alt: PropTypes.string,

    /**
     * The url of the image. This is used as an alternative to icon.
     */
    src: PropTypes.string
  }),

  /**
   * Action of the message for GA tracking
   */
  gaAction: PropTypes.string,

  /**
   * Category of the message for GA tracking
   */
  gaCategory: PropTypes.string,

  /**
   * Location of the message for GA tracking
   */
  gaLocation: PropTypes.string,

  /**
   * Surface of the message for GA tracking
   */
  gaSurface: PropTypes.string,

  /**
   * Treatment of the message for GA tracking
   */
  gaTreatment: PropTypes.string,
  additionalProps: PropTypes.shape({
    property: PropTypes.object,
    viewer: PropTypes.object,
    abadClient: PropTypes.func,
    zatlasEndpoint: PropTypes.string,
    shouldShowcheckBox: PropTypes.bool,
    signalForTriggerTracking: PropTypes.bool
  }),

  /**
   * The margin value to adjust spacing around the upsell UI.
   * Enter value in the format: top right bottom left
   * Default value: 0px 16px 0px 16px
   */
  overrideMargin: PropTypes.string,

  /**
   * When true, the text within `tagInput` prop will render top right on
   * the component.
   * Default value is false.
   */
  showAdvertisement: PropTypes.bool,

  /**
   * This text will populate in the top right corner of the component.
   * The `showAdvertisement` must be set to true for this to appear. Currently
   * this is set to false by default.
   * Default value is currently 'ADVERTISEMENT'
   */
  tagInput: PropTypes.string,

  /**
   * This trackingParameter indicates the lead source and lead type
   */
  trackingParameter: PropTypes.string
} : {};